import axios, {
  AxiosRequestConfig,
  AxiosRequestTransformer,
  AxiosResponseTransformer,
} from 'axios';
import camelize from 'camelize';
import snakeize from 'snakeize';

import { DOMAIN } from '@constants';

type Transformer = AxiosRequestTransformer | AxiosResponseTransformer;
const getDefaultTransfrom = <T extends Transformer>(
  func: T[] | T | undefined
): T[] => (func ? (Array.isArray(func) ? func : [func]) : []);

export const defaultTransformRequest = getDefaultTransfrom(
  axios.defaults.transformRequest
);
export const defaultTransformResponse = getDefaultTransfrom(
  axios.defaults.transformResponse
);

export const transformRequest: AxiosRequestTransformer[] = [
  (data: object) => {
    return snakeize(data);
  },
  ...defaultTransformRequest,
];

const chatieAPIConfig: AxiosRequestConfig = {
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  responseType: 'json',
  withCredentials: true,
  transformRequest,
  transformResponse: [
    ...defaultTransformResponse,
    (data: { result: object }) => {
      return camelize(data.result);
    },
  ],
};

export const api = axios.create(chatieAPIConfig);

api.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {};
  }

  if (typeof window !== 'undefined') {
    const CHEMING_DOMAIN = process.env.NEXT_PUBLIC_CHEMING_DOMAIN;
    const currentHost = window.location.host;
    const chemingHost = CHEMING_DOMAIN ? new URL(CHEMING_DOMAIN).host : '';
    const isCheming = currentHost === chemingHost;

    config.headers['X-SERVICE-ID'] = isCheming ? DOMAIN.cheming : DOMAIN.chatie;
  }
  return config;
});

export const camelizedAPIConfig: AxiosRequestConfig = {
  responseType: 'json',
  transformResponse: [
    ...defaultTransformResponse,
    (data) => {
      return camelize(data);
    },
  ],
};

const efinderCDNConfig: AxiosRequestConfig = {
  baseURL: process.env.NEXT_PUBLIC_EFINDER_CDN_URL,
  ...camelizedAPIConfig,
};

export const cdnApi = axios.create(efinderCDNConfig);
